import BALinearDiagram from './BALinearDiagram';

export default BALinearDiagram;
